export function AverageSurvey(props: any) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "80%",
        height: "80%",
        minHeight: "70px",
      }}
    >
      <svg
        width="70"
        height="70"
        viewBox="0 0 70 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ display: "block" }}
      >

        <rect width="70" height="70" rx="50" fill="#D1FADF" />
        
        <g transform="translate(12 9)">
          <path
            d="M33.75 33H17.35C16.7899 33 16.5099 33 16.296 32.891C16.1078 32.7951 15.9549 32.6422 15.859 32.454C15.75 32.2401 15.75 31.9601 15.75 31.4V15M32.75 20L28.8311 24.1827C28.6826 24.3412 28.6084 24.4204 28.5188 24.4614C28.4397 24.4976 28.3526 24.5125 28.266 24.5047C28.1679 24.4958 28.0715 24.4458 27.8787 24.3457L24.6213 22.6543C24.4285 22.5542 24.3321 22.5042 24.234 22.4953C24.1474 22.4875 24.0603 22.5024 23.9812 22.5386C23.8916 22.5796 23.8174 22.6588 23.6689 22.8173L19.75 27"
            stroke="#039855"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </svg>
    </div>
  );
}